// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__b+zEz","modal":"Modal_modal__yEgVW","close_icon":"Modal_close_icon__eEllH"};